import actions from '../../lib/api/actions';

export async function fetchCategories({ commit }) {
  const response = await actions.fetchCategories();

  if (response.status === 200) {
    commit('updateCategories', response.data);
  }
}
